import { apiFetchJson } from '@wundo/client/api.ts';
import type { TopOfMindResponse, TopOfMindStatus } from '@wundo/shared/topOfMind.ts';

export interface TopOfMindHolder {
  type: 'track' | 'cohort';
  id: string;
}

const REBUILD_POLL_MS = 3_000;
const SCHEDULED_POLL_MS = 15_000;

/** The summary being written or queued: worth polling until it settles. */
export function topOfMindIsBusy(status: TopOfMindStatus | undefined): boolean {
  return status === 'scheduled' || status === 'generating';
}

/** A debounced run is minutes away, so only a rebuild or a run in progress polls fast. */
export function topOfMindPollInterval(
  status: TopOfMindStatus | undefined,
  rebuilding: boolean,
): number | false {
  if (rebuilding || status === 'generating') return REBUILD_POLL_MS;
  if (status === 'scheduled') return SCHEDULED_POLL_MS;
  return false;
}

function holderQuery(holder: TopOfMindHolder): string {
  return new URLSearchParams({ [`${holder.type}_id`]: holder.id }).toString();
}

export async function getTopOfMind(holder: TopOfMindHolder): Promise<TopOfMindResponse> {
  return await apiFetchJson<TopOfMindResponse>(`/top-of-mind?${holderQuery(holder)}`);
}

export async function rebuildTopOfMind(
  holder: TopOfMindHolder,
): Promise<TopOfMindResponse> {
  return await apiFetchJson<TopOfMindResponse>(
    `/top-of-mind/rebuild?${holderQuery(holder)}`,
    {
      method: 'POST',
    },
  );
}
